import styled from "styled-components"
import useLocale from "../../hooks/useLocale"
import useTranslation from "../../hooks/useTranslation"

const Line = styled.div`
    margin-block:0.25rem;
    display: flex;
    justify-content: space-between;
`

const Decorator = styled.span`
    margin-block: 0rem;
    font-size: 0.6em;
`

const Label = styled.div`
    text-align: left;
    margin-right:5rem;    
`

const Value = styled.div`
    text-align: end;   
`

const H = styled.h3`
    margin-block:0rem;
`
const P = styled.p`
    margin-block:0rem;
    font-size: var(--font-XS);
`


function getValues(data, params, lf) {
    const result = [];

    for (const param of params) {
        if (Array.isArray(param)) {
            // If param is an array with two values, multiply the value from data by the second value.
            const [key, multiplier] = param;
            if (data[key] !== undefined) {
                result.push(data[key] * multiplier);
            }
        } else {
            // If param is a single key, get the value from data.
            if (data[param] !== undefined) {
                result.push(lf(data[param], 2, 2));
            }
        }
    }

    return result;
}


export const DisplayTotalsLine = ({ size, label, value = 0, params, line, decorator }) => {
    //logger.info('DisplayTotalsLine', label, value)
    const { m } = useTranslation()
    const { lf } = useLocale()
    let pLabel = label
    if (params) {
        const parameters = getValues(line, params, lf)
        pLabel = m(label, parameters)
    }

    return (
        <>
            {(size === 'normal') && <Line >
                <Label><P>{pLabel}</P></Label>
                <Value><P>{lf(value, 2, 2)}{decorator && <Decorator>{` ${decorator}`}</Decorator>}</P></Value>
            </Line>}
            {(size === 'large') && <Line >
                <Label><H>{pLabel}</H></Label>
                <Value><H>{lf(value, 2, 2)}{decorator && <Decorator>{` ${decorator}`}</Decorator>}</H></Value>
            </Line>}
        </>
    )
}


const DisplayTotalsSubLines = ({ field, data, decorator }) => {
    const lines = data[field.subEntity] || [];

    return (
        <>
            {lines.map(
                (line, i) => {
                    return (
                        <DisplayTotalsLine
                            key={i}
                            label={field.label}
                            size={field.scale}
                            value={line[field.value]}
                            params={field.labelParams}
                            line={line}
                            decorator={decorator}
                        />
                    )
                }
            )
            }
        </>

    )
}

export default DisplayTotalsSubLines